/**
 * Currency Settings Service
 * Handles user-based currency settings (base + extra currencies)
 */
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Get user's currency settings
 * @param {string} userId - User ID
 * @param {string} token - Auth token
 * @returns {Promise<{baseCurrency: string, allowedCurrencies: string[]}>}
 */
export const getCurrencySettings = async (userId, token) => {
  try {
    const response = await axios.get(
      `${BACKEND_URL}/api/users/${userId}/settings/currencies`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching currency settings:', error);
    throw error;
  }
};

/**
 * Update user's currency settings
 * @param {string} userId - User ID
 * @param {string} baseCurrency - Base currency code
 * @param {string[]} extraCurrencies - Extra currency codes (max 4)
 * @param {string} token - Auth token
 * @returns {Promise<{baseCurrency: string, allowedCurrencies: string[]}>}
 */
export const updateCurrencySettings = async (userId, baseCurrency, extraCurrencies, token) => {
  try {
    const response = await axios.put(
      `${BACKEND_URL}/api/users/${userId}/settings/currencies`,
      {
        baseCurrency,
        extraCurrencies
      },
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating currency settings:', error);
    throw error;
  }
};
